import Scenario from "./Scenario";
import ArrayIterator from "/lib/html5-software-library/src/ranj/util/datastructures/array/ArrayIterator";

/**
* ScenarioLibrary.js
* 
* Created on 8-okt-2013, 11:55:31
*
* @author Ivo Swartjes for Ranj
**/
export default class ScenarioLibrary {
    constructor() {
        /** @type {Scenario[]} */
        this._scenarios = [];
        /** @type {Scenario} */
        this._currentScenario;
        this._defaultScenario;
    };

    getCurrentScenario() {
        return this._currentScenario;
    };

    setCurrentScenario(scenario) {
        this._currentScenario = scenario;
    };

    getDefaultScenario() {
        return this._defaultScenario;
    };

    setDefaultScenario(scenario) {
        this._defaultScenario = scenario;
    };

    addScenario(scenario) {
        this._scenarios.push(scenario);
    };

    getScenarioByID(id) {
        for (var i = 0; i < this._scenarios.length; i++) {
            var scenario = this._scenarios[i];
            if (scenario.id === id) {
                return scenario;
            }
        }

        return null;
    };

    scenarioIterator() {
        return new ArrayIterator(this._scenarios);
    };

    getNextScenario() {
        const currentScenario = this.getCurrentScenario();
        if (!currentScenario) {
            return null;
        }

        const currentScenarioIndex = this._scenarios.indexOf(currentScenario);
        if (currentScenarioIndex + 1 >= this._scenarios.length) {
            return null;
        }

        return this._scenarios[currentScenarioIndex + 1];
    }

    get scenarios() {
        return this._scenarios;
    }
}